import CustomHead from 'components/commons/CustomHead'
import Template from 'components/contact-completed-lp'
import useLocalStorage from 'hooks/useLocalStorage'

const ContactCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDesignSystemLPContactPage')

  return (
    <>
      {fromCorrectFormPage ? (
        <CustomHead
          keyword={
            'Aitria（アイトリア） UX/UI デジタルトランスフォーメーション デザイン思考 デザイン経営 デザインパートナー サービスデザイン クラウドネイティブ'
          }
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/lp-designsystem-contact-completed/'}
          title="お問い合わせありがとうございました | Aitria（アイトリア）"
          description=""
          noindexNofollow={true}
        />
      ) : (
        <></>
      )}
      <Template />
    </>
  )
}

export default ContactCompleted
